// extracted by mini-css-extract-plugin
export default {"TipsSection":"styles_TipsSection__lNOGG","stepsTipsList":"styles_stepsTipsList__obye7"};